import React from "react";
import { Col, Form, Row } from "react-bootstrap";

export default function OrganizationType(props) {
  return (
    <>
      <Form.Group as={Row} controlId={props.id} className="mb-3">
        <Form.Label column sm={6} required={props.required}>{props.label}</Form.Label>
        <Form.Control
          required={props.required}
          as="select"
          name={props.id} onChange={props.onChange}
          value={props.state[props.id] ? props.state[props.id] : ""}
          data-hj-allow>
          <option value="">Choose Organization Type</option>
          <option value="LLC">LLC</option>
          <option value="C Corporation">C Corporation</option>
          <option value="S Corporation">S Corporation</option>
          <option value="Nonprofit">Nonprofit</option>
          <option value="Partnership">Partnership</option>
          <option value="Sole Proprietorship">Sole Proprietorship</option>
          <option value="Trust">Trust</option>
          <option value="Other">Other</option>
        </Form.Control>
      </Form.Group>
      {props.state.orgType === "Other" ? <>
        <Form.Group as={Row} controlId="otherOrgType" className="mb-3">
          <Form.Label column sm={6} required={props.required}>Specify Type</Form.Label>
          <Form.Control
            required={props.required}
            as="select"
            name="otherOrgType" onChange={props.onChange}
            value={props.state.otherOrgType ? props.state.otherOrgType : ""}
            data-hj-allow>
            <option value="">Select Type</option>
            <option value="Agency of the United States Government">Agency of
              the United States Government
            </option>
            <option value="Incorporated Association">Incorporated
              Association
            </option>
            <option value="Unincorporated Association">Unincorporated
              Association
            </option>
            <option value="Body Politic and Corporate">Body Politic and
              Corporate
            </option>
            <option value="Business Trust">Business Trust</option>
            <option value="Charitable Corporation">Charitable Corporation
            </option>
            <option value="Charitable Trust">Charitable Trust</option>
            <option value="Charitable, Non-profit Corporation">Charitable,
              Non-profit Corporation
            </option>
            <option value="Chartered Bank">Chartered Bank</option>
            <option
              value="Congressionally Chartered Nonprofit Organization">Congressionally Chartered
              Nonprofit Organization
            </option>
            <option value="Cooperative Association">Cooperative Association
            </option>
            <option value="Cooperative Corporation">Cooperative Corporation
            </option>
            <option value="Credit Union">Credit Union</option>
            <option value="Federal Agency">Federal Agency</option>
            <option value="Federally Chartered Credit Union">Federally
              Chartered Credit Union
            </option>
            <option value="Federally Chartered Corporation">Federally
              Chartered Corporation
            </option>
            <option
              value="Federally-recognized Indian Tribe">Federally-recognized Indian Tribe
            </option>
            <option value="Foundation">Foundation</option>
            <option value="Instrumentality">Instrumentality</option>
            <option value="Joint Stock Company">Joint Stock Company</option>
            <option value="Limited Liability Limited Partnership">Limited
              Liability Limited Partnership
            </option>
            <option value="Limited Liability Partnership">Limited Liability
              Partnership
            </option>
            <option value="Municipal Corporation">Municipal Corporation
            </option>
            <option value="National Banking Association">National Banking
              Association
            </option>
            <option value="Non-profit Association">Non-profit Association
            </option>
            <option value="Non-profit Corporation">Non-profit Corporation
            </option>
            <option value="Non-profit Organization">Non-profit Organization
            </option>
            <option value="Non-stock Corporation">Non-stock Corporation
            </option>
            <option value="Professional Corporation">Professional
              Corporation
            </option>
            <option value="Public Benefit Corporation">Public Benefit
              Corporation
            </option>
            <option value="State Agency">State Agency</option>
            <option value="State-recognized Indian Tribe">State-recognized
              Indian Tribe
            </option>
            <option value="State University">State University</option>
            <option value="Stock Company">Stock Company</option>
            <option value="Tax Exempt Corporation">Tax Exempt Corporation
            </option>
          </Form.Control>
        </Form.Group>
      </> : null}
    </>
  );
}